var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-5 mt-5 media-card",staticStyle:{"width":"250px"}},[_c('div',{ref:"dashboardContainer"}),_c('div',{ref:"dashboardProgress"})])}
var staticRenderFns = []

export { render, staticRenderFns }